<template>
	<div class="signal flex">
		<ul v-for="(col, i) in list" :key="i" class="flex" :class="{'flex-column': i != 1}">
			<li v-for="(item, j) in col" :key="j" class="flex-center flex-grow" :class="{'z-active': index == item}">指标{{item}}</li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			index: Number
		},

		computed: {
			list() {
				let temp = new Array(10).fill('').map((item, index) => index + 1);
				let list = [];
				list.push(temp.splice(0, 2));
				list.unshift(temp.splice(0, 4));
				list.push(temp.splice(0, 4));
				return list;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.signal {
		gap: 5px;

		ul {
			gap: 5px;

			li {
				width: 60px;
				height: 34px;
				border-radius: 4px;
				font-size: 12px;
				color: #999;
				background: #F5F5F5;

				&.z-active {
					color: #fff;
					background: var(--color-main);
				}
			}
		}
	}
</style>